import * as React from 'react';
import { BrowserRouter } from 'react-router-dom';
import AWSAppSyncClient, { createAppSyncLink, createLinkWithCache } from 'aws-appsync';
import { Rehydrated } from 'aws-appsync-react';
import { ApolloLink } from 'apollo-link';
import { RestLink } from 'apollo-link-rest';
import { withClientState } from 'apollo-link-state';
import { ApolloProvider } from 'react-apollo';
import Amplify, { Auth } from 'aws-amplify';
import userResolver from '../resolvers/user';
import { camelCase, merge } from 'lodash';
import Config from '../constants/Config';
import typeDefs from '../resolvers/typeDefs';
import App from './App';
import 'normalize.css';

const { auth, appsync } = Config;
Amplify.configure({ Auth: auth });

const restLink = new RestLink({
  uri: 'https://api.coinmarketcap.com/v2/',
  fieldNameNormalizer: name => camelCase(name),
  typePatcher: {
    CapMaps: data => {
      console.log('DATA', data);
      if (data.data != null) {
        data.data = data.data.map((item: any) => ({ __typename: 'CapMap', ...item }));
      }
      return data;
    },
  },
});

const stateLink = createLinkWithCache((cache: any) =>
  withClientState({
    ...merge(userResolver),
    cache,
    typeDefs,
  }),
);

const appSyncLink = createAppSyncLink({
  url: appsync.graphqlEndpoint,
  region: appsync.region,
  auth: {
    type: appsync.authenticationType,
    jwtToken: async () => (await Auth.currentSession()).getAccessToken().getJwtToken(),
  },
  complexObjectsCredentials: () => Auth.currentCredentials(),
});

const link = ApolloLink.from([restLink, stateLink, appSyncLink]);
const client = new AWSAppSyncClient({} as any, { link });

const Loader: any = <div>loading</div>;

const Root = () => (
  <ApolloProvider client={client}>
    <Rehydrated loading={Loader}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Rehydrated>
  </ApolloProvider>
);

export default Root;



// WEBPACK FOOTER //
// ./src/containers/Root.tsx